import { LogoutOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ROLE } from "../constant";
import { logout } from "./../app.slice";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo } from "react";
import { useFetchChecklistSettingsQuery } from "../pages/settings/setting.service";
import { isOwnerAccessRestricted } from "../utils/subscriptionAccess";

function Sidenav({ color = "#555555" }) {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const userData = useSelector((apps) => apps.app.user);
  const hasLabelGenerator = userData?.hasLabelGenerator === true;
  const { pathname } = useLocation();
  const page = pathname.split("/")[1];
  const navigate = useNavigate();

    console.log(hasLabelGenerator, "hasLabelGenerator");
    // ✅ Fetch checklist settings for visibility
  const { 
    data: checklistSettingsResponse, 
    refetch,
    isLoading 
  } = useFetchChecklistSettingsQuery(undefined, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });

  // ✅ Extract settings
  const checklistSettings = checklistSettingsResponse?.data || checklistSettingsResponse || {};

  // ✅ Refetch on settings update
  useEffect(() => {
    const handleSettingsChange = (event) => {
      console.log("📢 Settings updated, refetching...", event.detail);
      refetch();
    };
    
    window.addEventListener('settings-updated', handleSettingsChange);
    
    return () => {
      window.removeEventListener('settings-updated', handleSettingsChange);
    };
  }, []);

const menuItems = useMemo(() => {
  const baseItems = [
    {
      label: (
        <NavLink to="/home" style={{ backgroundColor: "rgb(109, 179, 63) " }}>
          <div style={{ color: page === "home" ? "yellow" : "white", width: "100%" }} className="label">
            {t("HOME")}
          </div>
        </NavLink>
      ),
      key: "dash",
      role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
    },
{
  label: (
    <NavLink to="/locations" style={{ backgroundColor: "rgb(109, 179, 63) " }}>
      <div style={{ color: page === "locations" ? "yellow" : "white", width: "100%" }} className="label">
        {t("LOCATIONS")}
      </div>
    </NavLink>
  ),
  key: "locations",
  role: [ROLE.RESTAURANT_ADMIN],
},
    {
      label: (
        <NavLink to="/restaurant" style={{ backgroundColor: "rgb(109, 179, 63) " }}>
          <div style={{ color: page === "restaurant" ? "yellow" : "white", width: "100%" }} className="label">
            {t("RESTAURANT")}
          </div>
        </NavLink>
      ),
      key: "restaurant",
      role: [ROLE.SUPER_ADMIN],
    },
    {
      label: (
        <NavLink to="/accounts" style={{ backgroundColor: "rgb(109, 179, 63) " }}>
          <div style={{ color: page === "accounts" ? "yellow" : "white", width: "100%" }} className="label">
            {t("ACCOUNTS")}
          </div>
        </NavLink>
      ),
      key: "accounts",
      role: [ROLE.SUPER_ADMIN],
    },
    {
      label: (
        <NavLink to="/compliance" style={{ backgroundColor: "rgb(109, 179, 63) " }}>
          <div style={{ color: page === "compliance" ? "yellow" : "white", width: "100%" }} className="label">
            {t("COMPLIANCE")}
          </div>
        </NavLink>
      ),
      key: "compliance",
      role: [ROLE.SUPER_ADMIN],
    },
    {
      label: (
        <NavLink to="/advert" style={{ backgroundColor: "rgb(109, 179, 63) " }}>
          <div style={{ color: page === "advert" ? "yellow" : "white", width: "100%" }} className="label">
            {t("ADVERT")}
          </div>
        </NavLink>
      ),
      key: "advert",
      role: [ROLE.SUPER_ADMIN],
    },
    {
      label: (
        <NavLink to="/openchecks" style={{ backgroundColor: "rgb(109, 179, 63) " }}>
          <div className="label" style={{ width: "100%", color: page === "openchecks" ? "yellow" : "white" }}>
            {t("OPENING CHECKS")}
          </div>
        </NavLink>
      ),
      role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
      key: "openchecks",
    },
    {
      label: (
        <NavLink to="/provechecks" style={{ backgroundColor: "rgb(109, 179, 63)" }}>
          <div className="label" style={{ width: "100%", color: page === "provechecks" ? "yellow" : "white" }}>
            {t("PROBE CHECKS")}
          </div>
        </NavLink>
      ),
      role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
      key: "provechecks",
    },
    {
      label: (
        <NavLink to="/closechecks" style={{ backgroundColor: "rgb(109, 179, 63) " }}>
          <div className="label" style={{ width: "100%", color: page === "closechecks" ? "yellow" : "white" }}>
            {t("CLOSING CHECKS")}
          </div>
        </NavLink>
      ),
      role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
      key: "closechecks",
    },
    {
      label: (
        <NavLink to="/weeklychecks" style={{ backgroundColor: "rgb(109, 179, 63)" }}>
          <div className="label" style={{ width: "100%", color: page === "weeklychecks" ? "yellow" : "white" }}>
            {t("WEEKLY CHECKS")}
          </div>
        </NavLink>
      ),
      role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
      key: "weeklychecks",
    },
    {
      label: (
        <NavLink to="/cleaning" style={{ backgroundColor: "rgb(109, 179, 63) " }}>
          <div className="label" style={{ width: "100%", color: page === "cleaning" ? "yellow" : "white" }}>
            {t("CLEANING LOG")}
          </div>
        </NavLink>
      ),
      role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
      key: "cleaning",
    },
    ...(checklistSettings?.monthly === true ? [{
      label: (
        <NavLink to="/monthlychecks" style={{ backgroundColor: "rgb(109, 179, 63)" }}>
          <div className="label" style={{ width: "100%", color: page === "monthlychecks" ? "yellow" : "white" }}>
            {t("MONTHLY CHECKS")}
          </div>
        </NavLink>
      ),
      role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
      key: "monthlychecks",
    }] : []),
    {
      label: (
        <NavLink to="/delivery" style={{ backgroundColor: "rgb(109, 179, 63)" }}>
          <div className="label" style={{ width: "100%", color: page === "delivery" ? "yellow" : "white" }}>
            {t("DELIVERY")}
          </div>
        </NavLink>
      ),
      role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
      key: "delivery",
    },
    {
      label: (
        <NavLink to="/supplier" style={{ backgroundColor: "rgb(109, 179, 63)" }}>
          <div className="label" style={{ width: "100%", color: page === "supplier" ? "yellow" : "white" }}>
            {t("SUPPLIER")}
          </div>
        </NavLink>
      ),
      role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
      key: "supplier",
    },
    {
      label: (
        <NavLink to="/team" style={{ backgroundColor: "rgb(109, 179, 63) " }}>
          <div className="label" style={{ width: "100%", color: page === "team" ? "yellow" : "white" }}>
            {t("TEAM")}
          </div>
        </NavLink>
      ),
      role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
      key: "team",
    },
    {
      label: (
        <NavLink to="/incidents" style={{ backgroundColor: "rgb(109, 179, 63) " }}>
          <div className="label" style={{ width: "100%", color: page === "incidents" ? "yellow" : "white" }}>
            {t("INCIDENTS")}
          </div>
        </NavLink>
      ),
      role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
      key: "incidents",
    },
    ...(hasLabelGenerator
      ? [
          {
            key: "label-submenu",
            label: t("LABEL GENERATOR"),
            role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
            children: [
              {
                key: "label-categories",
                label: (
                  <NavLink to="/label/categories">
                    <span style={{ color: "white" }}>{t("CATEGORIES")}</span>
                  </NavLink>
                ),
              },
              {
                key: "label-allergens",
                label: (
                  <NavLink to="/label/allergens">
                    <span style={{ color: "white" }}>{t("ALLERGENS")}</span>
                  </NavLink>
                ),
              },
            ],
          },
        ]
      : []),
    {
      label: (
        <NavLink to="/reports" style={{ backgroundColor: "rgb(109, 179, 63) " }}>
          <div className="label" style={{ width: "100%", color: page === "reports" ? "yellow" : "white" }}>
            {t("REPORTS")}
          </div>
        </NavLink>
      ),
      role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
      key: "reports",
    },
    {
      label: (
        <NavLink to="/allergy" style={{ backgroundColor: "rgb(109, 179, 63) " }}>
          <div className="label" style={{ width: "100%", color: page === "allergy" ? "yellow" : "white" }}>
            {t("ALLERGY CHECK")}
          </div>
        </NavLink>
      ),
      role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
      key: "allergy",
    },
    {
      label: (
        <NavLink to="/compliance_checks" style={{ backgroundColor: "rgb(109, 179, 63) " }}>
          <div className="label" style={{ width: "100%", color: page === "compliance_checks" ? "yellow" : "white" }}>
            {t("COMPLIANCE")}
          </div>
        </NavLink>
      ),
      role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
      key: "compliance_checks",
    },
    {
      label: (
        <NavLink to="/settings" style={{ backgroundColor: "rgb(109, 179, 63) " }}>
          <div className="label" style={{ width: "100%", color: page === "settings" ? "yellow" : "white" }}>
            {t("SETTINGS")}
          </div>
        </NavLink>
      ),
      role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
      key: "settings",
    },
    {
      label: (
        <NavLink to="/account" style={{ backgroundColor: "rgb(109, 179, 63) " }}>
          <div className="label" style={{ width: "100%", color: page === "account" ? "yellow" : "white" }}>
            {t("ACCOUNT")}
          </div>
        </NavLink>
      ),
      role: [ROLE.RESTAURANT_ADMIN, ROLE.RESTAURANT_USER, ROLE.LOCAL_ADMIN],
      key: "account",
    },
  ];

  return baseItems;
}, [page, t, checklistSettings?.monthly, hasLabelGenerator]);
  const accessRestricted = isOwnerAccessRestricted(userData);
  const filteredMenuItems = menuItems.filter((item) => {
    if (!item.role.includes(userData.role)) return false;
    // Inactive owner: Account only (resubscribe)
    if (accessRestricted) return item.key === "account";
    return true;
  });
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "95vh",
      }}
    >
      <div
        className="brand"
        style={{
          textAlign: "center",
          marginTop: "10px",
          color: "white",
          fontSize: "20px",
          marginBottom: "20px",
        }}
      >
        <img
          style={{ width: "170px", border: "1px solid #3a6f17" }}
          decoding="async"
          src={"/mark1.jpg"}
          alt="logo"
        />
      </div>
      <div style={{ flex: 1 }}>
        <Menu theme="light" mode="inline" items={filteredMenuItems}></Menu>
      </div>
      <div style={{ height: 50, display: "flex", alignItems: "center" }}>
        <div
          className="logoutlabel"
          style={{
            width: "100%",
            color: "white",
            cursor: "pointer",
            padding: "10px 16px",
            display: "flex",
            alignItems: "center",
            gap: 8,
            boxSizing: "border-box",
            fontWeight: 600,
          }}
          onClick={() => {
            dispatch(logout());
            navigate("/login");
            window.location.reload();
          }}
        >
          <LogoutOutlined />
          <span>{t("LOG OUT")}</span>
        </div>
      </div>
    </div>
  );
}

export default Sidenav;
